import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userAuth: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // Додає групу
    userLogInRedux(state) {
      state.userAuth = true;
    },
  },
});

export const { userLogInRedux } = userSlice.actions;

export default userSlice.reducer;
